/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesGoCampaign_PoliticalDistrictGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Political District Group Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Saturday, July 06, 2019 - 06:10:29 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      07/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const GoCampaign_PoliticalDistrictGroupList = Loadable({
    loader: () => import('../containers/GoCampaign_PoliticalDistrictGroups/GoCampaign_PoliticalDistrictGroupListContainer'),
    loading: Loading,
});

export const GoCampaign_PoliticalDistrictGroupForm = Loadable({
    loader: () => import('../containers/GoCampaign_PoliticalDistrictGroups/GoCampaign_PoliticalDistrictGroupEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesGoCampaign_PoliticalDistrictGroups.js